<template>
  <div class="app-container">
    <navigation title="读者问卷调查"></navigation>
    <div class="main">
      <div class="question-title">
        {{list.title}}
      </div>
      <div class="prefix" v-if="list.prefix">
        {{list.prefix}}
      </div>
      <component :is="item" v-for="(item, index) in allComponents" :key="item" :object="question[index]" :objectValue="index" @current="getCurrent"/>
      <van-form @submit="onSubmit">
        <div class="main-box" v-if="list.name">
          <div class="title"><span class="mandatory">*</span>姓名</div>
          <van-field
            v-model="userName"
            name="name"
            type="text"
            placeholder="请填写你的姓名"
            :rules="rules.name"
          />
        </div>
        <div class="main-box" v-if="list.idNumber">
          <div class="title"><span class="mandatory">*</span>身份证号</div>
          <van-field
            v-model="idCard"
            name="card"
            type="text"
            placeholder="请填写你的身份证号"
            :rules="rules.card"
          />
        </div>
        <div class="main-box" v-if="list.phone">
          <div class="title"><span class="mandatory">*</span>手机号</div>
          <van-field
            v-model="phone"
            name="tel"
            type="tel"
            placeholder="请填写你的手机号"
            :rules="rules.tel"
          />
        </div>
        <div class="main-box">
          <van-button class="submit" round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
import { request } from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Toast)

export default {
  name: 'question',
  components: {
    navigation,
    version,
    radio:()=>import('./components/radio.vue'),
    multi:()=>import('./components/multi.vue'),
    subjective:()=>import('./components/subjective.vue'),
  },
  data () {
    return {
      question:[],
      list:[],
      fillRadio:true,
      allComponents: [],
      userName: '',
      idCard: '',
      phone: '',
      rules:{
        name:[{pattern: /^[\u4e00-\u9fa5]{2,4}$/,message: '请输入正确的姓名',trigger: 'onBlur'}],
        card:[{pattern: /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '请输入正确的身份证号',trigger: 'onBlur'}],
        tel:[{pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,message: '请输入正确的手机号',trigger: 'onBlur'}]
      },
      data: [],
      flag:[]
    }
  },
  created () {
    this.getQuestion()
  },
  methods: {
    name(val){
      return /^[\u4e00-\u9fa5]{2,4}$/.test(val)
    },
    // 获取传参
    getCurrent(e){
      console.log('eeeee',e)
      if(this.data.length>0){
        this.data.forEach((item,index)=>{
          if(item.id === e.id){
            this.data.splice(index, 1)
          }
        })
      }
      this.data.push(e)
      console.log('this.data',this.data)
    },
    getQuestion(){
      let params = {
        id:this.$route.query.id
      }
      request('get', '/nlc-web/api/questionnaire/client', params).then(res => {
        console.log('问卷调查问题', res)
        this.list = res.data[0]
        this.question = res.data[0].questionInfoList
        this.question.forEach(item=>{
          if(item.questionType===1){
            this.allComponents.push('radio')
          } else if(item.questionType===2){
            this.allComponents.push('multi')
          } else {
            this.allComponents.push('subjective')
          }
        })
      })
    },
    onSubmit(){
      if(this.list.name && this.userName===''){
        Toast('请填写姓名')
        return
      } else if(this.list.idNumber && this.idCard===''){
        Toast('请填写身份证号')
        return
      } else if(this.list.phone && this.phone===''){
        Toast('请填写手机号')
        return
      }
      this.flag =[]
      this.question.forEach(item=>{
        if(item.requiredFlag===1){
          let state = this.data.some(function(e) {return e.id === item.id})
          if(!state){
            item.isshow = false
            this.flag.push(item)
            Toast('请填写问题')
          } else {
            item.isshow = true
            this.flag.push(item)
          }
        }
      })
      let params = {
        surveyId: this.$route.query.id,
        userName: this.userName,
        userIdNumber: this.idCard,
        userPhoneNumber: this.phone,
        questionInfoList: this.data
      }
      console.log('params',params)
      if(this.flag.findIndex(target=>target.isshow===false)===-1){
        console.log('验证通过')
        request('post', '/nlc-web/api/answerInfo', params).then(res => {
          console.log('提交问卷调查', res)
          if(res.code==200){
            this.$router.push(
              {
                path: `/parsing`,
                query: {
                  id: this.$route.query.id,
                }
              }
            )
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  overflow-y:scroll;
  background: #ecf5fd;
  width:100%;
  min-height: calc(100% - .92rem);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.main{
  margin:.92rem 0 0 0;
}
.question-title{
  background:#fff;
  padding:.23rem .27rem .25rem .27rem;
  margin-top:.16rem;
  font-size:.3rem;
  color: #46484B;
  text-align:center;
}
.prefix{
  background:#fff;
  padding:.23rem .27rem .25rem .27rem;
  margin-top:.16rem;
  font-size:.3rem;
  color: #46484B;
}
.main-box{
  background:#fff;
  padding:.23rem .27rem .25rem .27rem;
  margin-top:.16rem;
}
.title{
  font-size: .36rem;
  font-weight: 400;
  color: #46484B;
  margin-bottom:.2rem;
}
.moreChange{
  color:#008095;
}
.list li{
  height:.88rem;
  line-height:.88rem;
  font-size: .28rem;
  font-weight: 400;
  color: #46484B;
  padding-left:.29rem;
}
.active{
  background: rgba(0, 128, 149, 0.2);
  border-left:.17rem solid #008095;
  padding-left:.12rem !important;
}
.van-field{
  border:.02rem solid #E1E6EF ;
}
>>>.van-radio__label{
  font-size: .24rem;
  font-weight: 400;
  color: #46484B;
}
.van-radio-group{
  margin-left:.17rem;
}
.submit{
  width: 6.23rem;
  height: .88rem;
  background: #008095;
  border:0;
  box-shadow: inset -5px -5px 10px 0px rgba(125, 194, 209, 0.5);
  border-radius: 60px;
  font-weight: bold;
  font-size: .36rem;
  color: #FFFFFF;
  text-align:center;
  line-height:.88rem;
  margin:.24rem 0 0 .37rem;
}
.mandatory{
  color:#BA0000;
}
</style>



// WEBPACK FOOTER //
// src/view/question/index.vue